import ActionWarehouseTypes from "./warehouse.types";

export const WarehousetInitialState = {
  data: [],
};

export function WarehouseReducer(
  state: any = WarehousetInitialState,
  action: any
): any {
  switch (action.type) {
    case ActionWarehouseTypes.GET_WAREHOUSLIST:
      return {
        data: action.payload.list,
      };
    case ActionWarehouseTypes.ADD_WAREHOUSE:
      return { ...state, data: [action.payload.list, ...state.data] };
    case ActionWarehouseTypes.DELETE_WAREHOUSE:
      const filter = state.data.filter(
        (item: any) => item.id !== action.payload.id
      );
      return {
        ...state,
        data: filter,
      };
    case ActionWarehouseTypes.EDIT_WAREHOUSE:
      const filterEdit = state.data.filter(
        (item: any) => item.id !== action.payload.item.id
      );

      return {
        ...state,
        data: [action.payload.item, ...filterEdit],
      };

    default:
      return { ...state };
  }
}
